import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Router, UrlTree, CanActivateFn } from '@angular/router';

export const redirectFromSpaPathGuard: CanActivateFn = (
  _route,
  state
):
  | boolean
  | UrlTree
  | Promise<boolean | UrlTree>
  | Observable<boolean | UrlTree> => {
  // Remove '/spa' or '/Spa' from the beginning of the path, keeping the query parameters intact
  const newPath = state.url.replace(/^\/(spa|Spa)/, '');

  return inject(Router).parseUrl(newPath);
};
